// extracted by mini-css-extract-plugin
module.exports = {"mobile":"ContactForm_mobile__YqtX0"};